import { useState, useEffect } from 'react'
import Landing from './components/Landing'
import { getAuthClient } from './utils/auth'
import Spinner from './components/layout/Spinner'
import './App.scss'
import login from './Login.module.scss'
import logo from './logo.svg'

function App() {
  const auth = getAuthClient()

  const [isSubmitting, setSubmitting] = useState(false)

  const [result, setResult] = useState({
    success: null,
    error: null,
    message: '',
  })

  const defaultValues = { name: '', pass: '' }
  const [values, setValues] = useState(defaultValues)
  const [isLoggedIn, setLoggedIn] = useState(false)

  useEffect(() => {
    auth.isLoggedIn().then(() => {
      setLoggedIn(true)
    })
  }, [auth])

  const handleInputChange = (event) => {
    const { name, value } = event.target
    setValues({ ...values, [name]: value })
  }

  const handleSubmit = (event) => {
    event.preventDefault()
    setSubmitting(true)

    auth
      .login(values.name, values.pass)
      .then(() => {
        setSubmitting(false)
        setLoggedIn(true)
        setResult({ success: true, message: '' })
      })
      .catch((error) => {
        setSubmitting(false)
        setLoggedIn(false)
        setResult({
          error: true,
          message: `${error}`,
        })
      })
  }

  if (isLoggedIn) {
    const handleLogout = () => {
      auth.logout().then(setLoggedIn(false))
    }

    return <Landing onLogout={handleLogout} />
  }

  if (isSubmitting) {
    return <Spinner />
  }

  return (
    <div className={login[`login-form-wrap`]}>
      <div className={login[`login-form`]}>
        <img src={logo} className={login[`logo`]} alt='InScreen' />
        <h1 className='sr-only'>Log in to InScreen</h1>

        {(result.success || result.error) && (
          <div className={login[`error`]}>
            {/* {result.success ? '' : 'Error'} */}
            {result.message}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div>
            <label htmlFor='name' className={login[`form-label`]}>
              Username
            </label>
            <input
              name='name'
              id='name'
              type='text'
              value={values.name}
              className='form-control'
              onChange={handleInputChange}
            />
          </div>
          <div>
            <label htmlFor='pass' className={login[`form-label`]}>
              Password
            </label>
            <input
              name='pass'
              id='pass'
              type='password'
              value={values.pass}
              className='form-control'
              onChange={handleInputChange}
            />
          </div>
          <button name='submit' className='btn btn-primary'>
            Login
          </button>
        </form>
      </div>
    </div>
  )
}

export default App
